import React, { useEffect, useState } from 'react';
import { Classes, Dialog, Button, FormGroup, InputGroup, HTMLSelect } from '@blueprintjs/core';
import { uniqueNamesGenerator, adjectives, animals } from 'unique-names-generator';
import { postCreateSimulation } from '../api/cppmodelApi';
// import { saveAs } from 'file-saver';

interface CreateSimulationModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const CreateSimulationModal: React.FC<CreateSimulationModalProps> = ({ isOpen, onClose }) => {
    const [simulationName, setSimulationName] = useState('SimulationName');
    const [duration, setDuration] = useState(360);
    const [stepSize, setStepSize] = useState(1);
    const [buildEnvironment, setBuildEnvironment] = useState('windows-ucrt64');
    const [modelLanguage, setModelLanguage] = useState('C++');


    const generateName = () => {
        const newName = uniqueNamesGenerator({
            dictionaries: [adjectives, animals],
            separator: '_',
            length: 2,
        });
        setSimulationName(newName);
    };

    useEffect(() => {
        if (isOpen) {
            generateName();
        }
    }, [isOpen]);

    if (!isOpen) return null;

    // Make sure simulation name contains only alphanumeric characters and underscores, and starts with a letter
    const handleSimulationNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (/^[a-zA-Z][a-zA-Z0-9_]*$/.test(value)) {
            setSimulationName(value);
        }
    };


    const createSimulation = () => {
        postCreateSimulation({ params: {
            simulationName,
            language: modelLanguage,
            buildEnvironment: buildEnvironment,
            simulationTime: duration,
            stepSize: stepSize
        }}).then((data) => {
            console.log('Simulation created:', data);
            // Optionally handle the response data
        });
        onClose();
    }


    return (
        <Dialog
            isOpen={isOpen}
            onClose={onClose}
            title="Create New Simulation"
            canOutsideClickClose={true}
            canEscapeKeyClose={true}
        >
            <div className={Classes.DIALOG_BODY}>
                <FormGroup label="Simulation Name" labelFor="simulation-name">
                    <InputGroup
                        id="simulation-name"
                        value={simulationName}
                        onChange={(e) => handleSimulationNameChange(e)}
                        placeholder="Enter simulation name"
                    />
                </FormGroup>

                <FormGroup label="Duration (ms)" labelFor="duration">
                    <InputGroup
                        id="duration"
                        type="number"
                        value={duration.toString()}
                        onChange={(e) => setDuration(Number(e.target.value))}
                        placeholder="Enter duration"
                    />
                </FormGroup>

                <FormGroup label="Step Size (ms)" labelFor="step-size">
                    <InputGroup
                        id="step-size"
                        type="number"
                        value={stepSize.toString()}
                        onChange={(e) => setStepSize(Number(e.target.value))}
                        placeholder="Enter step size"
                    />
                </FormGroup>
                <FormGroup label="Language" >
                    <HTMLSelect
                        id="model-language"
                        value={modelLanguage}
                        onChange={(e) => setModelLanguage(e.currentTarget.value)}
                        options={['C', 'C++']}
                    />
                </FormGroup>
                <FormGroup label="Project" >
                    <HTMLSelect
                        id="build-environment"
                        value={buildEnvironment}
                        onChange={(e) => {setBuildEnvironment(e.currentTarget.value)}}
                        options={['None', 'linux', 'windows-ucrt64']}
                    />
                </FormGroup>

            </div>

            <div className={Classes.DIALOG_FOOTER}>
                <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                    <Button onClick={onClose}>
                        Cancel
                    </Button>
                    <Button intent="primary" onClick={createSimulation}>
                        Create
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default CreateSimulationModal;
